// extracted by mini-css-extract-plugin
module.exports = {"sideBysideWrapper":"sideBySide-module--sideBysideWrapper--PD_pM","headingSection":"sideBySide-module--headingSection--1Qa3h","ctaWrapper":"sideBySide-module--ctaWrapper--2-v8Q"};